<template>
    <div class="render--upload">
        <!-- 单个文件 -->
        <div
            v-if="typeof(data[header.field]) === 'string'"
            :class="isTable ? 'f_val':'form_value'"
        >
            <video
                v-if="isVideo_(data[header.field])"
                :src="data[header.field]"
                controls="controls"
                :class="isTable ?'uploadImg':'img'"
            />
            <img
                v-if="isImg_(data[header.field])"
                :src="data[header.field]"
                alt=""
                :class="isTable ?'uploadImg':'img'"
                @click="previewImg(data[header.field])"
            >
            <img
                v-if="isFile_(data[header.field])"
                :class="isTable ?'uploadImg':'img'"
                src="../../../assets/images/img_file.png"
                @click="download(fitem)"
            >
        </div>
        <!-- 多个文件 -->
        <div
            v-else
            class="form_value_flex"
        >
            <div
                v-for="(fitem,findex) in data[header.field]"
                :key="findex"
                class="form_value"
            >
                <video
                    v-if="isVideo_(fitem)"
                    :src="fitem"
                    controls="controls"
                    class="img"
                />
                <img
                    v-if="isImg_(fitem)"
                    :src="fitem"
                    alt=""
                    class="img"
                    @click="previewImg(fitem)"
                >
                <img
                    v-if="isFile_(fitem)"
                    class="uploadImg"
                    src="../../../assets/images/img_file.png"
                    @click="download(fitem)"
                >
            </div>
        </div>
        <!-- 预览 -->
        <previewImg
            :visible="dialogVisible"
            :url="imageUrl"
            @close="dialogVisible=false"
        />
    </div>
</template>

<script>

import previewImg from './previewImg.vue'
export default {
    name: 'RenderUpload',
    components: { previewImg },
    mixins: [],
    props: {
        data: {
            type: Object,
            default: null
        },
        header: {
            type: Object,
            default: null
        },
        isTable: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dialogVisible: false,
            imageUrl: '',
            videoSuffix: '.MOV,.AVI,.RMVB,.RM,.ASF,.DIVX,.MPG,.MPEG,.MPE,.WMV,.MP4,.MKV,.VOB,.mov,.avi,.rmvb ,.rm, .asf, .divx ,.mpg ,.mpeg ,.mpe ,.wmv, .mp4 ,.mkv, .vob',
            imgSuffix: '.BMP,.GIF,.JPEG,.JPG,.PSD,.PDD,.PNG,.TIFF,SVG,.bmp,.gif ,.jpeg, .jpg, .psd ,.pdd ,.png ,.tiff ,.svg',
            fileSuffix: '.DOC,.DOCX,.XLS,.XLSX,.PPT,.PDF,.TXT,.doc, .docx, .xls, .xlsx, .ppt, pdf, .txt'
        }
    },

    computed: {
        isVideo_() {
            return (url) => {
                return this.videoSuffix.indexOf(url.substring(url.lastIndexOf('.') + 1)) !== -1
            }
        },
        isImg_() {
            return (url) => {
                return this.imgSuffix.indexOf(url.substring(url.lastIndexOf('.') + 1)) !== -1
            }
        },
        isFile_() {
            return (url) => {
                return this.fileSuffix.indexOf(url.substring(url.lastIndexOf('.') + 1)) !== -1
            }
        }
    },

    created() {
    },

    methods: {

        previewImg(url) {
            this.dialogVisible = true
            this.imageUrl = url
        },
        download(item) {
            window.open(item, '_blank')
        }
    }
}
</script>
<style rel="stylesheet/scss" lang="scss">
.render--upload {
    cursor: pointer;

    img {
        width: 100px;
        border: 1px solid #c0ccda;
        border-radius: 6px;
    }
}
</style>
